module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-left-217d71066c1db7c2f1bb47036227ac47.svg";